//Comentario necesario para codificación en UTF-8, ver Inc6743
//03956 Modificacion de nombre y descripcion de la version
(function () {
	var App = angular.module('pphhApp');
	App.service("PPHHManagementService", ["$http", PPHHManagementService] );
	
	function PPHHManagementService ($http) {
		this.saveVersion = saveVersion;
		function saveVersion (nombre, descripcion, cicloId, modulo){
			var params= {
				nombre:nombre,
				descripcion: descripcion,
				cicloId:cicloId,
				modulo:modulo
			}
			var url = _contextPath + "/pphh-sgpusa-versionEditSave";
			var request = {
				method: "POST",
				url: url,
				data: params
			};
			
			request.headers = {};
			request.headers[_csrf_headerName] = _csrf_token;
			return $http(request);
		}
	}	
})();
